import * as React from "react";
import ApiSurveys from "../../api/surveys";
import { useSinkActions, useToastActions } from "context/";
import {
  confirmArchiveSurvey,
  confirmRestoreSurvey,
} from "./surveyArchive";

export function useSurveyArchive(survey: { id: number }) {
  const { resink } = useSinkActions();
  const { showError } = useToastActions();
  const [isOpen, setIsOpen] = React.useState(false);
  const [isPending, setIsPending] = React.useState(false);
  const [isRestoring, setIsRestoring] = React.useState(false);

  const open = React.useCallback(() => setIsOpen(true), []);

  const close = React.useCallback(() => {
    if (!isPending) setIsOpen(false);
  }, [isPending]);

  const confirm = React.useCallback(() => {
    setIsPending(true);
    confirmArchiveSurvey({
      archive: () => ApiSurveys.archiveSurvey(survey.id),
      resink,
      onError: showError,
    })
      .then((ok) => {
        if (ok) setIsOpen(false);
      })
      .finally(() => {
        setIsPending(false);
      });
  }, [survey.id, resink, showError]);

  const restore = React.useCallback(() => {
    if (isRestoring) return;
    setIsRestoring(true);
    confirmRestoreSurvey({
      restore: () => ApiSurveys.restoreSurvey(survey.id),
      resink,
      onError: showError,
    }).finally(() => {
      setIsRestoring(false);
    });
  }, [survey.id, resink, showError, isRestoring]);

  return {
    isOpen,
    open,
    close,
    isPending,
    confirm,
    restore,
    isRestoring,
  };
}

export type SurveyArchiveControls = ReturnType<typeof useSurveyArchive>;
